import { render } from "./MissingWorksWizard.vue?vue&type=template&id=5287923a&scoped=true"
import script from "./MissingWorksWizard.vue?vue&type=script&lang=js"
export * from "./MissingWorksWizard.vue?vue&type=script&lang=js"

import "./MissingWorksWizard.vue?vue&type=style&index=0&id=5287923a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5287923a"]])

export default __exports__